import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import ScrollReveal from './ScrollReveal';
import Seo from './Seo';
import { SOLUTIONS, INDUSTRIES } from '../solutions/data';

function Solutions() {
    return (
        <main>
            <Seo
                title="Solutions — Qcoda | Governed AI Orchestration"
                description="Qcoda solutions: governed AI software delivery, architecture acceleration, AI-assisted audit and compliance, and governed research and campaign planning."
                path="/solutions"
            />

            <section className="site-section-lg">
                <Container>
                    <Row className="justify-content-center text-center">
                        <Col lg={9} xl={8}>
                            <ScrollReveal animation="fade-in">
                                <span className="badge-ea mb-4 d-inline-block">Solutions</span>
                            </ScrollReveal>
                            <ScrollReveal animation="fade-up" delay={100}>
                                <h1 className="hero-headline mb-4">
                                    One platform. Four ways to put governed AI to work.
                                </h1>
                            </ScrollReveal>
                            <ScrollReveal animation="fade-up" delay={200}>
                                <p className="hero-sub mx-auto mb-4">
                                    Qcoda is the orchestration and governance layer for AI at work.
                                    Every solution ships with the same alignment thread — leadership,
                                    line-of-business owners, and the people doing the work all see the
                                    same ledger, the same guardrails, and the same evidence.
                                </p>
                            </ScrollReveal>
                        </Col>
                    </Row>
                </Container>
            </section>

            <hr className="section-divider" />

            <section className="site-section">
                <Container>
                    <Row className="justify-content-center g-4">
                        {SOLUTIONS.map((s, i) => (
                            <Col md={6} key={s.slug}>
                                <ScrollReveal animation="fade-up" delay={i * 100} className="h-100">
                                    <Link to={`/solutions/${s.slug}`} className="text-decoration-none">
                                        <div className="glass-card h-100">
                                            <p className="text-dim" style={{ fontSize: '0.75rem', textTransform: 'uppercase', letterSpacing: '0.08em', marginBottom: '0.5rem' }}>
                                                {s.eyebrow}
                                            </p>
                                            <h3 style={{ fontSize: '1.35rem', fontWeight: 600, marginBottom: '0.75rem', color: 'white' }}>
                                                {s.title}
                                            </h3>
                                            <p style={{ fontSize: '1rem', color: 'rgba(255,255,255,0.75)', marginBottom: '1rem' }}>
                                                {s.tagline}
                                            </p>
                                            <p className="text-muted-white" style={{ fontSize: '0.9rem', lineHeight: 1.65, margin: 0 }}>
                                                {s.summary}
                                            </p>
                                            <p style={{ marginTop: '1rem', marginBottom: 0, fontSize: '0.9rem', color: 'rgba(120,170,240,0.9)' }}>
                                                {s.cta} &rarr;
                                            </p>
                                        </div>
                                    </Link>
                                </ScrollReveal>
                            </Col>
                        ))}
                    </Row>
                </Container>
            </section>

            <hr className="section-divider" />

            <section className="site-section">
                <Container>
                    <Row className="justify-content-center text-center mb-4">
                        <Col lg={8}>
                            <ScrollReveal animation="fade-up">
                                <span className="eyebrow-quiet">Industries we work with</span>
                                <h2 className="section-heading mt-3 mb-3">
                                    Where governance is not optional.
                                </h2>
                                <p className="section-subheading">
                                    Qcoda is built for organizations that operate under scrutiny —
                                    regulatory, fiduciary, reputational, or all three.
                                </p>
                            </ScrollReveal>
                        </Col>
                    </Row>
                    <Row className="justify-content-center g-3">
                        {INDUSTRIES.map((ind, i) => (
                            <Col xs={6} md={3} key={ind.slug}>
                                <ScrollReveal animation="fade-up" delay={i * 50}>
                                    <div className="glass-card text-center" style={{ padding: '1.25rem 0.75rem' }}>
                                        <p style={{ margin: 0, fontWeight: 500, color: 'white' }}>{ind.name}</p>
                                    </div>
                                </ScrollReveal>
                            </Col>
                        ))}
                    </Row>
                </Container>
            </section>
        </main>
    );
}

export default Solutions;
